import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'Airport Transportation', href: '/services/airport-transportation' },
  { label: 'Wedding Transportation', href: '/services/wedding-transportation' },
  { label: 'Corporate Transportation', href: '/services/corporate-transportation' },
  { label: 'Event Transportation', href: '#contact' },
  { label: 'Prom Transportation', href: '#contact' },
  { label: 'Private Chauffeur', href: '#contact' },
  { label: 'Charleston Sights Tours', href: '#contact' },
  { label: 'Cruises & Port Transport', href: '#contact' },
];

const locationLinks = [
  { label: 'Charleston, SC', href: '/location/charleston-sc' },
  { label: 'Mount Pleasant, SC', href: '/location/charleston-sc' },
  { label: 'North Charleston, SC', href: '/location/charleston-sc' },
  { label: 'Summerville, SC', href: '/location/charleston-sc' },
];

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileServices, setMobileServices] = useState(false);
  const [mobileLocations, setMobileLocations] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-neutral-950/98 backdrop-blur-sm py-3 border-b border-gold/15'
          : 'bg-transparent py-5'
      }`}
    >
      {/* Top contact bar */}
      <div
        className={`overflow-hidden transition-all duration-300 ${
          scrolled ? 'max-h-0 opacity-0' : 'max-h-8 opacity-100'
        }`}
      >
        <div className="flex items-center justify-end gap-8 px-8 pb-2 text-xs text-white/55">
          <a href="mailto:tecslimoservice@gmail.com" className="flex items-center gap-1.5 hover:text-gold transition-colors cursor-pointer">
            <div className="w-3 h-3 flex items-center justify-center"><i className="ri-mail-line"></i></div>
            tecslimoservice@gmail.com
          </a>
          <a href="tel:+18435130018" className="flex items-center gap-1.5 hover:text-gold transition-colors cursor-pointer">
            <div className="w-3 h-3 flex items-center justify-center"><i className="ri-phone-line"></i></div>
            (843) 513-0018
          </a>
          <span className="flex items-center gap-1.5 text-gold font-semibold">
            <div className="w-3 h-3 flex items-center justify-center"><i className="ri-time-line"></i></div>
            Open 24/7
          </span>
        </div>
      </div>

      <div className="px-8 flex items-center justify-between gap-8">
        {/* Logo */}
        <Link to="/" className="flex flex-col leading-none cursor-pointer group flex-shrink-0">
          <span className="text-gold font-display text-2xl font-bold tracking-widest uppercase group-hover:text-gold-light transition-colors">TECS</span>
          <span className="text-white/55 text-[10px] tracking-[0.25em] uppercase font-light">Limo Service LLC</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          <Link to="/" className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide cursor-pointer whitespace-nowrap">Home</Link>
          <Link to="/about" className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide cursor-pointer whitespace-nowrap">About Us</Link>

          {/* Services */}
          <div className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
            <button className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide flex items-center gap-1 cursor-pointer whitespace-nowrap">
              Services
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${servicesOpen ? 'rotate-180' : ''}`}></i>
              </div>
            </button>
            <div className={`absolute top-full left-1/2 -translate-x-1/2 mt-4 w-56 bg-neutral-950 border border-gold/25 py-2 transition-all duration-200 ${servicesOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
              <div className="h-0.5 bg-gradient-to-r from-transparent via-gold/60 to-transparent mb-2"></div>
              {serviceLinks.map((s) => (
                s.href.startsWith('/') ? (
                  <Link key={s.label} to={s.href} className="block px-5 py-2.5 text-xs text-white/65 hover:text-gold hover:bg-gold/5 transition-colors tracking-wide cursor-pointer">{s.label}</Link>
                ) : (
                  <a key={s.label} href={s.href} className="block px-5 py-2.5 text-xs text-white/65 hover:text-gold hover:bg-gold/5 transition-colors tracking-wide cursor-pointer">{s.label}</a>
                )
              ))}
            </div>
          </div>

          {/* Locations */}
          <div className="relative" onMouseEnter={() => setLocationsOpen(true)} onMouseLeave={() => setLocationsOpen(false)}>
            <button className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide flex items-center gap-1 cursor-pointer whitespace-nowrap">
              Locations
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${locationsOpen ? 'rotate-180' : ''}`}></i>
              </div>
            </button>
            <div className={`absolute top-full left-1/2 -translate-x-1/2 mt-4 w-52 bg-neutral-950 border border-gold/25 py-2 transition-all duration-200 ${locationsOpen ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
              <div className="h-0.5 bg-gradient-to-r from-transparent via-gold/60 to-transparent mb-2"></div>
              {locationLinks.map((l) => (
                <Link key={l.label} to={l.href} className="block px-5 py-2.5 text-xs text-white/65 hover:text-gold hover:bg-gold/5 transition-colors tracking-wide cursor-pointer">{l.label}</Link>
              ))}
            </div>
          </div>

          <a href="#contact" className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide cursor-pointer whitespace-nowrap">Contact</a>
        </nav>

        {/* Desktop CTA */}
        <a
          href="tel:+18436422440"
          className="hidden lg:flex items-center gap-2 bg-gold hover:bg-gold-light transition-all text-black font-bold px-6 py-3 text-sm whitespace-nowrap cursor-pointer tracking-wide flex-shrink-0"
        >
          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm"></i></div>
          (843) 642-2440
        </a>

        {/* Mobile toggle */}
        <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden text-white cursor-pointer w-8 h-8 flex items-center justify-center" aria-label="Toggle menu">
          <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ${mobileOpen ? 'max-h-[700px]' : 'max-h-0'}`}>
        <div className="bg-neutral-950 border-t border-gold/20 px-6 py-4 space-y-1">
          <Link to="/" className="block py-3 text-white/80 hover:text-gold text-sm border-b border-white/5 cursor-pointer">Home</Link>
          <Link to="/about" className="block py-3 text-white/80 hover:text-gold text-sm border-b border-white/5 cursor-pointer">About Us</Link>
          <button onClick={() => setMobileServices(!mobileServices)} className="flex items-center justify-between w-full py-3 text-white/80 hover:text-gold text-sm border-b border-white/5 cursor-pointer whitespace-nowrap">
            Services
            <div className="w-4 h-4 flex items-center justify-center"><i className={`ri-arrow-down-s-line transition-transform ${mobileServices ? 'rotate-180' : ''}`}></i></div>
          </button>
          {mobileServices && (
            <div className="pl-4 pb-1 border-b border-white/5">
              {serviceLinks.map((s) => (
                s.href.startsWith('/') ? (
                  <Link key={s.label} to={s.href} className="block py-2 text-white/50 hover:text-gold text-xs tracking-wide cursor-pointer">{s.label}</Link>
                ) : (
                  <a key={s.label} href={s.href} className="block py-2 text-white/50 hover:text-gold text-xs tracking-wide cursor-pointer">{s.label}</a>
                )
              ))}
            </div>
          )}
          <button onClick={() => setMobileLocations(!mobileLocations)} className="flex items-center justify-between w-full py-3 text-white/80 hover:text-gold text-sm border-b border-white/5 cursor-pointer whitespace-nowrap">
            Locations
            <div className="w-4 h-4 flex items-center justify-center"><i className={`ri-arrow-down-s-line transition-transform ${mobileLocations ? 'rotate-180' : ''}`}></i></div>
          </button>
          {mobileLocations && (
            <div className="pl-4 pb-1 border-b border-white/5">
              {locationLinks.map((l) => (
                <Link key={l.label} to={l.href} className="block py-2 text-white/50 hover:text-gold text-xs tracking-wide cursor-pointer">{l.label}</Link>
              ))}
            </div>
          )}
          <a href="#contact" className="block py-3 text-white/80 hover:text-gold text-sm border-b border-white/5 cursor-pointer">Contact</a>
          <a href="tel:+18436422440" className="mt-4 block bg-gold text-black font-bold px-4 py-3 text-center text-sm whitespace-nowrap cursor-pointer tracking-wide">
            Call (843) 642-2440
          </a>
        </div>
      </div>
    </header>
  );
}
